import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import { useNavigate } from 'react-router-dom';
import WaitImg from '../assets/wait.json';
import Item from '../components/Item';
import Spacer from '../components/Spacer';
import { sleep } from '../utils/utils';
import useFormStore from "../state/useFormStore";

const Wrapper = styled.div`
  height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 36px;
  margin-top: 20px;
  padding-bottom: 100px;
`;

const TitleText = styled.h2`
  font-size: 20px;
  line-height: 24px;
  margin: 20px 0;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.basic1000};
`;

const MainText = styled.div`
  margin: 10px 0 20px 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.basic2000};
`;

const Subtext = styled.h4`
  font-size: 20px;
  line-height: 26px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.basic2000};
  margin: 5px 0 40px 0;
  text-align: center;
`;

const Wait = () => {
  const navigate = useNavigate();
  const [waitOver, setWaitOver] = useState(false);
  const { preOffers, requestUid } = useFormStore(state => ({
    preOffers: state.preOffers,
    requestUid: state.requestUid
  }));

  useEffect(() => {
    window.scrollTo({ top: 0 });

    const timer = setTimeout(() => {
      setWaitOver(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (waitOver) {
      if (preOffers && preOffers.length > 0) {
        // navigate(`/${requestUid}/ofertas`);
        navigate(`/${requestUid}/cbu`);
      } else {
        navigate(`/${requestUid}/rechazado`);
      }
    }
  }, [waitOver, preOffers, requestUid, navigate]);

  return (
    <Wrapper>
      <TitleText style={{ fontWeight: '800' }}>Buscando ofertas...</TitleText>
      <Lottie animationData={WaitImg} height={150} width={150} style={{ width: '200px' }} />
      <MainText>¡Gracias por elegirnos!</MainText>
      <Subtext>¡Estamos buscando las mejores ofertas! Faltan <strong>algunos segundos...</strong></Subtext>
      <Spacer size={30} />
    </Wrapper>
  );
};

export default Wait;